
<h1>Change Password</h1>

<form (submit)="submit($event)">
    <div>
        <mat-form-field>
            <input matInput
                   placeholder="Email"
                   [formField]="resetPasswordForm.email">
            <mat-error></mat-error>
        </mat-form-field>
    </div>
    <div>
        <aa-password-input label="Password"
                           [hint]="passwordHint"
                           [formField]="resetPasswordForm.password"></aa-password-input>
    </div>
    <div>
        <aa-password-input id="password2_field"
                           label="Confirm password"
                           [formField]="resetPasswordForm.password2"></aa-password-input>
    </div>
    <div id="button_row">
        <button mat-raised-button
                class="button"
                type="submit"
                color="primary"
                [disabled]="resetPasswordForm().invalid() || isBusy()">Change Password</button>
    </div>
</form>
